/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './workspace-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-workspace-list-page',
  template
})
export class WorkspaceListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.wor.workspaces.workspace';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: '', label: 'type', sortable: false}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }
}
